import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const createPurchasingLead = async (params) => {
    const data = transformCreateLeadData(params);

    try {
        const res = await leadsServiceApi({
            method: 'post',
            url: PURCHASING_API.LEADS,
            data,
        });
        const leadId = res.data.leadId;

        return {
            result: true,
            options: {
                _id: leadId
            }
        }
    } catch (e) {
        return {
            msg: e.message,
            error: e
        };
    }

};

const transformCreateLeadData = (params) => ({
    source: params.marketing?.source,
    name: params.ref_lead_customer?.full_name,
    emailAddress: params.ref_lead_customer?.email,
    phone: params.ref_lead_customer?.phone,
    countyId: params.ref_lead_customer?.address?.county,
    preferredContactMethod: params.ref_lead_customer?.preferred_contact_method,
    preferredContactTime: params.ref_lead_customer?.preferred_contact_time,
    chassisNumber: params.chassisNumber,
    year: params.ref_bike_lead?.bike_year,
    engineSize: params.ref_bike_lead?.unmaped_data?.bike_cc,
    mileage: params.ref_bike_lead?.mileage,
    nonRunner: params.ref_bike_lead?.non_runner,
    serviceHistory: params.ref_bike_lead?.document_history,
    bikeCondition: params.ref_bike_lead?.condition,
    motHistory: params.ref_bike_lead?.mot_history_customer,
    raceReplica: params.ref_bike_lead?.race_replica,
    colour: params.ref_bike_lead?.colour,
    previousOwners: params.ref_bike_lead?.previous_owner_count,
    insuranceWriteOff: params.ref_bike_lead?.written_off,
    vrm: params.ref_bike_lead?.vrm,
    makeId: params.ref_bike_lead?.ref_bike_brand,
    make: params.make,
    variantId: params.ref_bike_lead?.ref_bike_variant,
    modelId: params.ref_bike_lead?.ref_bike_model,
    model: params.model,
    hasPanniers: params.ref_bike_lead?.panniers,
    division: params.ref_lead_source,
    selectedBikeId: params.part_ex?.is_part_ex === true ? params.part_ex?.ref_bike_inventory : undefined,
    dataSource: 'crm'
});


// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/requests/create_lead_request.js